'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useState } from 'react';

import type { Gallery } from '../../pages/gallery/page';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function GalleryCard({ gallery }: { gallery: Gallery }) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const fallbackImage = '/images/no-image.png';
  const allImages = [gallery.image, ...gallery.images].filter(Boolean);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className="relative col-span-1 w-full overflow-hidden rounded-lg">
        <button
          type="button"
          aria-label={gallery.name}
          onClick={handleOpenGallery(allImages, 0)}
          className="block w-full border-0 bg-transparent p-0"
        >
          <Image
            src={gallery.image?.url || fallbackImage}
            alt={resolveImageAlt(gallery?.image, gallery?.name)}
            width={0}
            height={0}
            className="h-[180px] w-full cursor-pointer object-cover object-center sm:h-[220px] lg:h-[240px]"
            sizes="100vw"
          />
        </button>
        <div className="flex w-full flex-col items-start justify-start gap-2 bg-input p-4">
          <h4 className="text-base font-bold sm:text-lg lg:text-xl">{gallery?.name}</h4>
          <HtmlRenderer
            html={gallery.description ?? ''}
            className={cn('w-full sm:line-clamp-2 sm:h-12', 'ea-gallery-card__description')}
          />
        </div>
      </div>
    </>
  );
}
